/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button, DropDown, Input } from "../../components";
import { toast } from "react-toastify";
import {
  validateCharacterLength,
  validatePositiveValue,
  numberValidation,
} from "../../utilities/utils";
import {
  GetSettingConfig,
  UpdateSettingConfig,
} from "../../utilities/api/setting-config";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { messages } from "../../utilities/Messages";

const getMessage = messages.settings;

const Settings = () => {
  let initialState = {
    sessionEndDateLimit: "",
    rewardPointsPercent: "",
    minApplicableRewardPoints: "",
    minRewardPointsToClaim: "",
    allocateRewardPoints: false,
    appUnderMaintenance: false,
    dashboardDefaultInterval: "",
    courtIgst: 0 || "",
    courtCgst: "",
    courtSgst: "",
    courtSacCode: "",
    sessionIgst: "",
    sessionCgst: "",
    sessionSgst: "",
    sessionSacCode: "",
  };
  const [data, setData] = useState(initialState);
  const [error, setError] = useState({
    ...initialState,
    allocateRewardPoints: "",
  });
  const { UserRole } = useAppSelector((state) => state.verifiedUser);

  useEffect(() => {
    GetSettingConfig()
      .then((res) => {
        updateData(res?.data || initialState);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  }, []);

  const updateData = (key: any, value: any = "") => {
    if (typeof key === "object") {
      setData((oldSession) => ({ ...oldSession, ...key }));
    } else {
      setData((oldSession) => ({ ...oldSession, [key]: value }));
    }
  };

  const isValid = () => {
    if (
      !data?.sessionEndDateLimit ||
      !data?.rewardPointsPercent ||
      numberValidation(data?.rewardPointsPercent) == null ||
      !data?.minApplicableRewardPoints ||
      !data?.minRewardPointsToClaim ||
      !data?.dashboardDefaultInterval ||
      !data?.courtIgst ||
      numberValidation(Number(data?.courtIgst)) == null ||
      !data?.courtCgst ||
      numberValidation(Number(data?.courtCgst)) == null ||
      !data?.courtSgst ||
      numberValidation(Number(data?.courtSgst)) == null ||
      data?.courtSacCode?.length < 6 ||
      data?.courtSacCode?.length > 6 ||
      !data?.sessionIgst ||
      numberValidation(Number(data?.sessionIgst)) == null ||
      !data?.sessionCgst ||
      numberValidation(Number(data?.sessionCgst)) == null ||
      !data?.sessionSgst ||
      numberValidation(Number(data?.sessionSgst)) == null ||
      data?.sessionSacCode?.length < 6 ||
      data?.sessionSacCode?.length > 6
    ) {
      setError({
        ...error,
        sessionEndDateLimit: data?.sessionEndDateLimit
          ? ""
          : getMessage.sessionEndDateLimit_required,
        rewardPointsPercent: data?.rewardPointsPercent
          ? numberValidation(data?.rewardPointsPercent) == null
            ? getMessage.rewardPointsPercent_valueType
            : ""
          : getMessage.rewardPointsPercent_required,
        minApplicableRewardPoints: data?.minApplicableRewardPoints
          ? ""
          : getMessage.minApplicableRewardPoints_required,
        minRewardPointsToClaim: data?.minRewardPointsToClaim
          ? ""
          : getMessage.minRewardPointsToClaim_required,
        dashboardDefaultInterval: data?.dashboardDefaultInterval
          ? ""
          : getMessage.dashboardDefaultInterval_required,
        courtIgst:
          Number(data?.courtIgst) > 0
            ? numberValidation(Number(data?.courtIgst)) == null
              ? getMessage.courtIgst_valueType
              : ""
            : getMessage.courtIgst_required,
        courtCgst:
          Number(data?.courtCgst) > 0
            ? numberValidation(Number(data?.courtCgst)) == null
              ? getMessage.courtCgst_valueType
              : ""
            : getMessage.courtCgst_required,
        courtSgst:
          Number(data?.courtSgst) > 0
            ? numberValidation(Number(data?.courtSgst)) == null
              ? getMessage.courtSgst_valueType
              : ""
            : getMessage.courtSgst_required,
        courtSacCode:
          data?.courtSacCode?.length < 6 || data?.courtSacCode?.length > 6
            ? getMessage.courtSacCode_length
            : "",
        sessionIgst:
          Number(data?.sessionIgst) > 0
            ? numberValidation(Number(data?.sessionIgst)) == null
              ? getMessage.sessionIgst_valueType
              : ""
            : getMessage.sessionIgst_required,
        sessionCgst:
          Number(data?.sessionCgst) > 0
            ? numberValidation(Number(data?.sessionCgst)) == null
              ? getMessage.sessionCgst_valueType
              : ""
            : getMessage.sessionCgst_required,
        sessionSgst:
          Number(data?.sessionSgst) > 0
            ? numberValidation(Number(data?.sessionSgst)) == null
              ? getMessage.sessionSgst_valueType
              : ""
            : getMessage.sessionSgst_required,
        sessionSacCode:
          data?.sessionSacCode?.length < 6 || data?.sessionSacCode?.length > 6
            ? getMessage.sessionSacCode_length
            : "",
      });
      return false;
    }
    setError({ ...initialState, allocateRewardPoints: "" });
    return true;
  };

  const handleSubmit = async () => {
    if (isValid()) {
      let payload = {
        sessionEndDateLimit: data?.sessionEndDateLimit
          ? Number(data?.sessionEndDateLimit)
          : 0,
        rewardPointsPercent: data?.rewardPointsPercent
          ? Number(data?.rewardPointsPercent)
          : 0,
        minApplicableRewardPoints: data?.minApplicableRewardPoints
          ? Number(data?.minApplicableRewardPoints)
          : 0,
        minRewardPointsToClaim: data?.minRewardPointsToClaim
          ? Number(data?.minRewardPointsToClaim)
          : 0,
        allocateRewardPoints: data?.allocateRewardPoints,
        appUnderMaintenance: data?.appUnderMaintenance,
        dashboardDefaultInterval: data?.dashboardDefaultInterval,
        courtIgst: data?.courtIgst ? Number(data?.courtIgst) : 0,
        courtCgst: data?.courtCgst ? Number(data?.courtCgst) : 0,
        courtSgst: data?.courtSgst ? Number(data?.courtSgst) : 0,
        courtSacCode: data?.courtSacCode ? data?.courtSacCode : "",
        sessionIgst: data?.sessionIgst ? Number(data?.sessionIgst) : 0,
        sessionCgst: data?.sessionCgst ? Number(data?.sessionCgst) : 0,
        sessionSgst: data?.sessionSgst ? Number(data?.sessionSgst) : 0,
        sessionSacCode: data?.sessionSacCode ? data?.sessionSacCode : "",
      };
      const result = await UpdateSettingConfig(payload);
      if (result?.status === 200) {
        localStorage.setItem(
          "dashboard-default-date",
          data?.dashboardDefaultInterval
        );
        toast.success(result?.data?.message);
      } else {
        toast.error(result.response.data.message);
      }
    }
  };


  const setValueWithLength = (key = "", value = "", min = 0, max = 0) => {
    if (validateCharacterLength(value, min, max)) {
      updateData(key, value);
    }
  };

  const setPositiveValue = (key = "", value = "") => {
    if (validatePositiveValue(value)) {
      updateData(key, value);
    }
  };



  const handleDateChange = (e: any) => {
    updateData("dashboardDefaultInterval", e.target.value);
  };

  return (
    <>
      <Container fluid>
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="text-start mb-0">Settings</Card.Title>
            </div>
            <hr />
            <Row className="mb-3 text-start">
              <label
                htmlFor="dashboard"
                className="form-label col-form-label col-sm-3"
              >
                Dashboard Default Period{" "}
              </label>
              <div className="col-sm-3 text-start">
                <DropDown
                  className="form-control"
                  id="dashboard"
                  name="dashboard"
                  value={data?.dashboardDefaultInterval}
                  onChange={(e: any) => handleDateChange(e)}
                >
                  <option value="">Select Default Period</option>
                  <option value="today">Today</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="yearly">Yearly</option>
                </DropDown>
                <span className="error-msg">
                  {error?.dashboardDefaultInterval}
                </span>
              </div>
            </Row>

            <Row className="mb-3 text-start">
              <label
                htmlFor="rewardPointsPercent"
                className="form-label col-form-label col-sm-3"
              >
                Reward Points Percent
              </label>
              <div className="col-sm-3 text-start">
                <Input
                  type="text"
                  className="form-control"
                  name="rewardPointsPercent"
                  id="rewardPointsPercent"
                  value={data?.rewardPointsPercent}
                  onChange={(e: any) => {
                    if (e.target.value >= 0 && e.target.value <= 100) {
                      setPositiveValue("rewardPointsPercent", e.target.value);
                    }
                  }}
                />
                <span className="error-msg">{error?.rewardPointsPercent}</span>
              </div>
            </Row>
            <Row className="mb-3 text-start">
              <label
                htmlFor="minApplicableRewardPoints"
                className="form-label col-form-label col-sm-3"
              >
                Min Applicable Reward Points
              </label>
              <div className="col-sm-3 text-start">
                <Input
                  type="text"
                  className="form-control"
                  name="minApplicableRewardPoints"
                  id="minApplicableRewardPoints"
                  value={data?.minApplicableRewardPoints}
                  onChange={(e: any) =>
                    setPositiveValue(
                      "minApplicableRewardPoints",
                      e.target.value
                    )
                  }
                />
                <span className="error-msg">
                  {error?.minApplicableRewardPoints}
                </span>
              </div>
            </Row>
            <Row className="mb-3 text-start">
              <label
                htmlFor="minRewardPointsToClaim"
                className="form-label col-form-label col-sm-3"
              >
                Min Reward Points To Claim
              </label>
              <div className="col-sm-3 text-start">
                <Input
                  type="text"
                  className="form-control"
                  name="minRewardPointsToClaim"
                  id="minRewardPointsToClaim"
                  value={data?.minRewardPointsToClaim}
                  onChange={(e: any) =>
                    setPositiveValue("minRewardPointsToClaim", e.target.value)
                  }
                />
                <span className="error-msg">
                  {error?.minRewardPointsToClaim}
                </span>
              </div>
            </Row>
            <Row className="align-items-center mb-3 text-start">
              <label
                title=""
                htmlFor="custom-switch-reward"
                className="form-check-label col-form-label col-sm-3"
              >
                Allocate Reward Points
              </label>
              <div className="col-sm-3 text-start">
                <div className="form-check form-switch">
                  <Input
                    type="checkbox"
                    id="custom-switch-reward"
                    name="status"
                    className="form-check-input"
                    checked={data?.allocateRewardPoints}
                    onChange={(e: any) =>
                      updateData(
                        "allocateRewardPoints",
                        !data?.allocateRewardPoints
                      )
                    }
                  />
                </div>
              </div>
            </Row>
            <Row className="align-items-center mb-3 text-start">
              <label
                title=""
                htmlFor="custom-switch-maintenance"
                className="form-check-label col-form-label col-sm-3"
              >
                App Under Maintenance
              </label>
              <div className="col-sm-3 text-start">
                <div className="form-check form-switch">
                  <Input
                    type="checkbox"
                    id="custom-switch-maintenance"
                    name="status"
                    className="form-check-input"
                    checked={data?.appUnderMaintenance}
                    onChange={(e: any) =>
                      updateData(
                        "appUnderMaintenance",
                        !data?.appUnderMaintenance
                      )
                    }
                    disabled={UserRole.id != 1}
                  />
                </div>
              </div>
            </Row>
            <hr />
            <Row>
              <div className="fs-5 fw-semibold mb-3 text text-start">Court</div>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="sac-code" className="form-label">
                      SAC Code <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      if (Number(e?.target?.value) >= 0)
                        setValueWithLength(
                          "courtSacCode",
                          e?.target?.value,
                          0,
                          10
                        );
                    }}
                    value={data?.courtSacCode}
                    type="number"
                    name="sac-code"
                    id="sac-code"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{error?.courtSacCode}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="i-gst" className="form-label">
                      IGST (%) <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      const igst = Number(e?.target?.value);
                      if (igst >= 0 && igst <= 100) {
                        const _updatedValues = {
                          courtIgst: `${igst}`,
                          courtCgst: `${igst / 2}`,
                          courtSgst: `${igst / 2}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                    value={data?.courtIgst}
                    type="number"
                    name="i-gst"
                    id="i-gst"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{error?.courtIgst}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="c-gst" className="form-label">
                      CGST (%) <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      const cgst = Number(e?.target?.value);
                      const igst = cgst + Number(data?.courtSgst);
                      if (igst >= 0 && igst <= 100 && cgst >= 0) {
                        const _updatedValues = {
                          courtIgst: `${igst}`,
                          courtCgst: `${cgst}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                    value={data?.courtCgst}
                    type="number"
                    name="c-gst"
                    id="c-gst"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{error?.courtCgst}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="s-gst" className="form-label">
                      SGST (%) <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      const sgst = Number(e?.target?.value);
                      const igst = sgst + Number(data?.courtCgst);
                      if (igst >= 0 && igst <= 100 && sgst >= 0) {
                        const _updatedValues = {
                          courtIgst: `${igst}`,
                          courtSgst: `${sgst}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                    value={data?.courtSgst}
                    type="number"
                    name="s-gst"
                    id="s-gst"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{error?.courtSgst}</span>
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <div className="fs-5 fw-semibold mb-3 text text-start">
                Session
              </div>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="sac-code" className="form-label">
                      SAC Code <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      if (Number(e?.target?.value) >= 0)
                        setValueWithLength(
                          "sessionSacCode",
                          e?.target?.value,
                          0,
                          10
                        );
                    }}
                    value={data?.sessionSacCode}
                    type="number"
                    name="sac-code"
                    id="sac-code"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{error?.sessionSacCode}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="i-gst" className="form-label">
                      IGST (%) <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      const igst = Number(e?.target?.value);
                      if (igst >= 0 && igst <= 100) {
                        const _updatedValues = {
                          sessionIgst: `${igst}`,
                          sessionCgst: `${igst / 2}`,
                          sessionSgst: `${igst / 2}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                    value={data?.sessionIgst}
                    type="number"
                    name="i-gst"
                    id="i-gst"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{error?.sessionIgst}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="c-gst" className="form-label">
                      CGST (%) <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      const cgst = Number(e?.target?.value);
                      const igst = cgst + Number(data?.sessionSgst);
                      if (igst >= 0 && igst <= 100 && cgst >= 0) {
                        const _updatedValues = {
                          sessionIgst: `${igst}`,
                          sessionCgst: `${cgst}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                    value={data?.sessionCgst}
                    type="number"
                    name="c-gst"
                    id="c-gst"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{error?.sessionCgst}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="s-gst" className="form-label">
                      SGST (%) <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      const sgst = Number(e?.target?.value);
                      const igst = sgst + Number(data?.sessionCgst);
                      if (igst >= 0 && igst <= 100 && sgst >= 0) {
                        const _updatedValues = {
                          sessionIgst: `${igst}`,
                          sessionSgst: `${sgst}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                    value={data?.sessionSgst}
                    type="number"
                    name="s-gst"
                    id="s-gst"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{error?.sessionSgst}</span>
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col lg={12} className="text-end">
                <Button
                  type="button"
                  bname="Save"
                  name="save"
                  id="save"
                  className="btn btn-primary rounded-1 "
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { Settings };
